import { getColor } from '@/helpers';
import { IMainWidgetSettings, IWidgetColor } from '@/types/components/widget';
import styled from 'styled-components';

interface IProps {
  widgetSettings: IMainWidgetSettings;
  widgetColor: IWidgetColor;
}

export const Animation = styled.div<IProps>`
  @keyframes dropdown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes border-error-blink {
    0% {
      border-color: ${({ widgetColor, widgetSettings }) =>
        getColor(widgetSettings.colorScheme, widgetColor, 'body', 'errorColor')};
    }
    50% {
      border-color: transparent;
    }
    100% {
      border-color: ${({ widgetColor, widgetSettings }) =>
        getColor(widgetSettings.colorScheme, widgetColor, 'body', 'errorColor')};
    }
  }
`;
